<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6" fill="#388F27" stroke="white" v-if="isBgGreen"/>
    <circle cx="8.5" cy="8" r="6" fill="#008D3F" stroke="#008D3F" stroke-width="2"  v-if="!isWhite && !isBgGreen"/>
    <path d="M5.83464 8L7.83464 10L11.168 6" stroke="white" stroke-width="2"  v-if="!isWhite || isBgGreen"/>
    <circle cx="8.5" cy="8" r="6" fill="white" stroke="white" stroke-width="2"  v-if="isWhite && !isBgGreen"/>
    <path d="M5.83464 8L7.83464 10L11.168 6" stroke="#008D3F" stroke-width="2"  v-if="isWhite && !isBgGreen"/>
  </svg>

</template>

<script>
export default {
  name: 'SuccessCart',

  props: {
    isWhite: Boolean,
    heightValue: Number,
    widthValue: Number,
    isBgGreen: {
      type: Boolean,
      default: false
    }
  }
}

</script>
<style lang='scss'>
</style>
